import React, { useEffect, useState } from 'react'
import { send, useFibaMsgBox, useLoading } from '../components'
import { Grid, GridColumn } from '@progress/kendo-react-grid'
import { Checkbox } from '@progress/kendo-react-inputs'

const Roles = () => {
    const { showLoading } = useLoading()
    const { error } = useFibaMsgBox()
    const [roles, setRoles] = useState([])
    const [columns, setColumns] = useState([])

    const getRoleList = async () => {
        const res = await send("vo000005", {}, showLoading);
        if (res.status === 'error') {
            error(res.message)
        } else {
            setRoles(res.roles)
            setColumns(res.process)
        }
    }

    useEffect(() => {
        getRoleList()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const handleCheckboxChange = async (e, userId, processCode) => {
        const checked = e.value ? 1 : 0;

        // UI state-д өөрчлөлт оруулах
        const updatedRoles = roles.map(row => {
            if (row.userid === userId) {
                return { ...row, [processCode]: checked };
            }
            return row;
        });

        setRoles(updatedRoles);

        // Сервер рүү update илгээх (жишээ)
        const res = await send("vo000006", {
            userid: userId,
            process: processCode,
            role: checked
        }, showLoading);

        if (res.status === 'error') {
            error(res.message)
        }
    };

    // custom checkbox cell
    const CheckboxCell = ({ dataItem, field }) => {
        return (
            <td>
                <Checkbox
                    checked={dataItem[field] === 1}
                    onChange={(e) => handleCheckboxChange(e, dataItem.userid, field)}
                />
            </td>
        );
    };

    return (
        <div>
            <Grid
                data={roles}
                editable={true}
            >
                <GridColumn
                    field='user_name'
                    title='Хэрэглэгч'
                    width={100}
                />
                {columns.map((item, index) => <GridColumn
                    key={index}
                    field={item.pc}
                    title={item.name}
                    cell={CheckboxCell}
                    width={120}
                />)}
            </Grid>
        </div>
    )
}

export default Roles